/**
 * Demo-build stub for `@hellopearl/cl-logger`.
 *
 * The demo harness must never ship logs off the page, and the private
 * registry packages aren't needed to render the sandbox — so
 * `demo/vite.config.ts` aliases the package here (same isolation idea as
 * its `process.env.*` stubs). Only the symbols the demo bundle graph
 * imports are provided; warn/error still reach the devtools console so
 * demo breakage stays visible.
 */

interface StubLogger {
  debug(message: string, data?: Record<string, unknown>): void;
  info(message: string, data?: Record<string, unknown>): void;
  warn(message: string, data?: Record<string, unknown>): void;
  error(message: string, data?: Record<string, unknown>): void;
  child(bindings: Record<string, unknown>): StubLogger;
}

function makeLogger(scope: string): StubLogger {
  return {
    debug: () => {},
    info: () => {},
    warn: (message, data) => console.warn(`[demo:${scope}] ${message}`, data ?? ''),
    error: (message, data) => console.error(`[demo:${scope}] ${message}`, data ?? ''),
    child: () => makeLogger(scope),
  };
}

export function createLogger(scope: string, ..._rest: unknown[]): StubLogger {
  return makeLogger(scope);
}

export function setGlobalTransport(..._args: unknown[]): void {}
export function setAppVersion(..._args: unknown[]): void {}
export function setMinLevel(..._args: unknown[]): void {}
export function configureClientLogging(..._args: unknown[]): void {}

export class ConsoleTransport {
  log(..._args: unknown[]): void {}
}

export const BATCH_FLUSH_INTERVAL_MS = 30_000;
export const BATCH_MAX_BUFFER = 1_000;
export const BATCH_SIZE = 50;

export class BatchBuffer {
  enqueue(..._args: unknown[]): void {}
  flush(): unknown[] {
    return [];
  }
}
